/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from "react";
import { useLocation, matchPath } from "react-router";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Drawer, List, ListSubheader, colors } from "@material-ui/core";
import { NavItem } from "src/components";
import { menuStorage } from "src/common/Storage";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  mobileDrawer: {
    width: 256,
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: "calc(100% - 64px)",
    borderRadius: 15,
    margin: 15,
  },
  navigation: {
    overflow: "auto",
    padding: theme.spacing(0, 2, 2, 2),
    flexGrow: 1,
  },
  profile: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
  },
  badge: {
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
  badgeDot: {
    height: 9,
    minWidth: 9,
  },
  onlineBadge: {
    backgroundColor: colors.green[600],
  },
  awayBadge: {
    backgroundColor: colors.orange[600],
  },
  busyBadge: {
    backgroundColor: colors.red[600],
  },
  offlineBadge: {
    backgroundColor: colors.grey[300],
  },
  avatar: {
    cursor: "pointer",
    width: 40,
    height: 40,
  },
  details: {
    marginLeft: theme.spacing(2),
  },
  moreButton: {
    marginLeft: "auto",
    color: colors.blueGrey[200],
  },
}));

function renderNavItems({ items, subheader, key, ...rest }) {
  return (
    <List key={key}>
      {subheader && <ListSubheader disableSticky>{subheader}</ListSubheader>}
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, ...rest }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth = 0, ...rest }) {
  const { i18n } = rest;
  if (item.items && item.items.length > 0) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        key={uuidv4()}
        label={item.label}
        open={Boolean(open)}
        title={i18n.language === "th" ? item.titleTH : item.titleEN}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
          key: uuidv4(),
          i18n,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        appCode={item.appCode}
        icon={item.icon}
        key={uuidv4()}
        label={item.label}
        title={i18n.language === "th" ? item.titleTH : item.titleEN}
      />
    );
  }

  return acc;
}
function NavBar({ onToogleMenu, className, ...rest }) {
  const classes = useStyles();
  const location = useLocation();
  const [menus, setMenus] = useState([]);
  const { i18n } = useTranslation();

  useEffect(() => {
    setMenus(menuStorage.getMenu() || []);
  }, []);

  const content = (
    <div {...rest} className={clsx(classes.root, className)}>
      <nav className={classes.navigation}>
        {menus.map((list) =>
          renderNavItems({
            items: list.items,
            subheader: list.subheader,
            pathname: location.pathname,
            key: uuidv4(),
            i18n,
          })
        )}
      </nav>
    </div>
  );

  return (
    <>
      <Drawer
        classes={{
          paper: classes.desktopDrawer,
        }}
        variant="persistent"
        anchor="left"
        open={onToogleMenu}
      >
        {content}
      </Drawer>
    </>
  );
}

NavBar.propTypes = {
  className: PropTypes.string,
  onToogleMenu: PropTypes.bool,
};

export default NavBar;
